import RenderAttribute from "components/PayoutManagement/previews/RenderAttribute";
import { PayoutMethodType } from "containers/PayoutManagement/types";
import React from "react";

interface ICheckPreviewProps {
  defaultPayoutMethod: PayoutMethodType;
}

const CheckPreview: React.FC<ICheckPreviewProps> = ({
  defaultPayoutMethod,
}) => {
  return (
    <>
      <RenderAttribute label={"Name: "} value={defaultPayoutMethod.name} />
      <RenderAttribute
        label={"Street Address: "}
        value={`${defaultPayoutMethod.address1}, ${defaultPayoutMethod.city}, ${defaultPayoutMethod.state},${defaultPayoutMethod.country}`}
      />
    </>
  );
};

export default CheckPreview;
